function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.266-.937H-6.563V-11.016A.234.234,0,0,0-6.8-11.25h-.469a.234.234,0,0,0-.234.234V-.469A.469.469,0,0,0-7.031,0h14.3A.234.234,0,0,0,7.5-.234V-.7A.234.234,0,0,0,7.266-.937ZM-4.619-5.419a.234.234,0,0,0,0,.331l.331.331a.234.234,0,0,0,.331,0l2.13-2.11L.654-4.385a.469.469,0,0,0,.663,0l2.74-2.74,1.29,1.29a.7.7,0,0,0,.5.21.711.711,0,0,0,.717-.713v-3.5a.474.474,0,0,0-.474-.474h-3.5a.711.711,0,0,0-.5,1.215l1.31,1.31L.986-5.379-1.493-7.859a.469.469,0,0,0-.661,0ZM3.134-9.375H5.625v2.491Z",
  transform: "translate(7.5 11.25)",
  opacity: 0.871
});

var SvgIconSide10 = function SvgIconSide10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11.25,
    viewBox: "0 0 15 11.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-10.71b1794c.svg";
export { ForwardRef as ReactComponent };